export default {"src":"/_next/static/media/djibouti.505fd140.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};